import modal from '../../smartpak/modal.js';
import { antiForgeryPost } from '../../utils/fetch.js';


const wishList = {
    alreadyInitialized: false,
    init: function (onWishListAdd) {
        if (this.alreadyInitialized) {
            return;
        }

        this.alreadyInitialized = true;

        document.querySelector('.wishlistLink a')?.addEventListener('click', e => {
            e.preventDefault();
            this._handleClick(e.currentTarget, onWishListAdd);
        });
    },
    _handleClick: async function ($element, onWishListAdd) {
        const { posturl: url, productclassid: productclassId, productid: selectedProductId } = $element.dataset;

        const content = await this._postItemToWishlist(url, { productclassId, selectedProductId });

        this._show(content);

        if (typeof onWishListAdd === 'function') {
            onWishListAdd();
        }
    },
    _show: function (html) {
        const $wishList = document.getElementById('wishListContent');

        if ($wishList) {
            $wishList.innerHTML = html;

            modal($wishList, {
                width: '450px',
                title: 'Added to My Wishlist'
            });
        }
    },
    _postItemToWishlist: async function (url, { productclassId, selectedProductId }) {
        const response = await antiForgeryPost(url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                productclassId,
                selectedProductId
            })
        });

        return await response.text();
    }
};

export default wishList;